import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0A0A0C] text-white flex items-center justify-center p-6 grid-bg">
      <div className="max-w-lg w-full border border-white/10 bg-[#121215] p-10" data-testid="payment-cancel-card">
        <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-white/40 mb-4">Paiement annulé</div>
        <h1 className="font-display text-4xl font-black tracking-tight mb-4">Aucun paiement effectué.</h1>
        <p className="text-white/60 mb-8">Vous pouvez retenter l'abonnement à tout moment depuis le dashboard.</p>
        <Link
          to="/"
          data-testid="payment-cancel-back-btn"
          className="inline-flex items-center gap-3 bg-white text-black px-6 py-3 font-mono text-sm uppercase tracking-widest hover:bg-[#FF453A]"
        >
          <ArrowLeft className="w-4 h-4" /> Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}
